<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Add Branded Style for {{dealershipName}}</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body" [class.hidden]="loadingData">
        <div class="input-container">
            <span class="label">Brand Name <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">style</i>
            </span>
            <input [(ngModel)]="brandName" type="text" placeholder="TrackTreads Brand" required>
        </div>
        <div class="input-container">
            <span class="label">Colour Scheme <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">format_color_fill</i>
            </span>
            <select [(ngModel)]="selectedColourSchemeId" required>
                <option value="" disabled selected>Select Colour Scheme</option>
                <option *ngFor="let colourScheme of colourSchemes" [value]="colourScheme.Id">{{colourScheme.Name}}</option>
            </select>
        </div>
        <div class="input-container">
            <span class="label">Logout Redirect Url <span class="red-text">*</span></span>
            <input [(ngModel)]="logoutRedirectUrl" type="text" placeholder="http://www.dealership.com" required>
        </div>
        <div class="input-container">
            <span class="label">Identity Server Url <span class="red-text">*</span></span>
            <input [(ngModel)]="identityServerUrl" type="text" placeholder="login.example.com" required>
        </div>
        <div class="input-container">
            <span class="label">Undercarriage Url <span class="red-text">*</span></span>
            <input [(ngModel)]="undercarriageUrl" type="text" placeholder="undercarriage.example.com" required>
        </div>
        <div class="input-container">
            <span class="label">Undercarriage UI Url <span class="red-text">*</span></span>
            <input [(ngModel)]="undercarriageUiUrl" type="text" placeholder="undercarriageui.example.com" required>
        </div>
        <div class="input-container">
            <span class="label">GET Url <span class="red-text">*</span></span>
            <input [(ngModel)]="getUrl" type="text" placeholder="get.example.com" required>
        </div>
        <div class="input-container">
            <span class="label">GET UI Url <span class="red-text">*</span></span>
            <input [(ngModel)]="getUiUrl" type="text" placeholder="getui.example.com" required>
        </div>
        <span class="input-description">Upload a logo for the dealership. Recommended 77px by 35px. <span class="red-text">*</span></span>
        <input type='file' (change)="onSelectImage($event)">
        <div style="margin-top: 8px;">
            <img *ngIf="imageUrl" [src]="imageUrl" height="70" width="154">
        </div>
    </div>
    <mat-spinner  *ngIf="loadingData"></mat-spinner>
    <div class="ttmodal__footer" [class.hidden]="loadingData">
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="addNewBrandedStyle()" [class.loading]="savingBrand"><span class="button__text">Add Branded Style</span></a>
    </div>
</div>